/* eslint max-len: ["error", { "code": 150 }] */
import * as moment from 'moment';
import {
  ValidatorFn, AbstractControl, UntypedFormControl, ValidationErrors
} from '@angular/forms';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { defaultFieldConfig } from './configs/default-field-config';
import { FormFieldService } from '../services/form-field.service';


export function dateComparator(date1ControlName, date2ControlName, operator): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any } => {
    const date1 = formGroup.get(date1ControlName).value;
    const date2 = formGroup.get(date2ControlName).value;
    // console.log('date1', date1);
    // console.log('date2', date2);
    // console.log(moment(date1)[operator](moment(date2)));
    return moment(date1)[operator](moment(date2)) ? { 'invalidDate' : true} : null;
  };
}

export function noWhitespaceValidator(control: UntypedFormControl) {
  if (!control.value || control.value.length === 0) return null;
  const value = (control.value || '').toString();
  const firstCharacter = value.charAt(0);
  const isFirstCharacterWhiteSpace = firstCharacter === ' ';
  const isFirstCharacterTab = firstCharacter === '\t';
  const isWhitespace = value.trim().length === 0;
  const isValid = !isWhitespace && !isFirstCharacterWhiteSpace && !isFirstCharacterTab;
  return isValid ? null : { 'whitespace': true };
}

export function minWords(minWords): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value || control.value.length === 0) return null;
      const wordCount = control.value.trim().split(' ').length;
      const isValid = minWords <= wordCount;
      return isValid ? null : { 'minWords': minWords };
  };
}

export function checkStreetType(control): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any } => {
    const streetType = formGroup.get(control).value;
    const isValid = !!(streetType);
    return isValid ? null : { 'streetTypeSet': true };
  };
}

export function checkStateType(control): ValidatorFn {
  return (formGroup: AbstractControl): { [key: string]: any } => {
    const stateType = formGroup.get(control).value;
    const isValid = !!(stateType);
    return isValid ? null : { 'stateTypeSet': true };
  };
}

/**
 * Reusable validator that checks the value if it matches the required length
 * @param requiredLength the required length size
 */
export function exactLengthValidator(requiredLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    /** Return null if no value, let required validator handle that */
    if (!control?.value) {
      return null;
    }

    if (control.value.length === requiredLength) {
      return null;
    }

    return { exactLength: { requiredLength: length, actualLength: control.value.length } }
  }
}

export function InvalidSiblingFormControlValidator(excludedFormControlName?: string|string[]):ValidatorFn {
  const excludedFcNames = typeof excludedFormControlName === 'string' ? [excludedFormControlName] : excludedFormControlName;
  return (fc: AbstractControl):{ [key: string]: any } => {
    let hasInvalid = false;
    if (fc.parent.invalid) {
      const fcNames = Object.keys(fc.parent.controls).filter((name) => !excludedFcNames.includes(name));
      hasInvalid = fcNames.some((name) => fc.parent.get(name).invalid);
    }
    return hasInvalid ? {
      'hasInvalidSiblingFormControl': true
    } : null;
  }
}

@Injectable({
  providedIn: 'root',
})
export class CustomValidator {
/**
 * Validator for name
 * @param fieldConfig(object) - Field Configuration(default: defaultConfig.name)
 * @returns ValidationErrors | null
 */
  static nameValidator(fieldConfig: any = defaultFieldConfig.name) {
    return (control: UntypedFormControl): ValidationErrors | null => {
      // get config
      const config = _.get(fieldConfig, 'config') || {};
      if (_.isEmpty(config)) {
        return { error: true };
      }
      // Validate form field using plugin
      const validationErrors = FormFieldService.validateFormField({ value: control.value }, config);
      return validationErrors;
    };
  }

  /**
 * Validator for drivers licence number and drivers licence card number
  * @param fieldConfig(object) - Field Configuration(default: defaultFieldConfig.driversLicenceNumber)
 * Must be defaultFieldConfig.driversLicenceNumber or defaultFieldConfig.driversLicenceCardNumber
 * @param genericConfig(array) - Array of configuration that is generic regardless of state
 * @param statePath(string) - Path of object to get state value(default: 'state')
 * @returns
 */
  static driversLicenceValidator(fieldConfig: any = defaultFieldConfig.driversLicenceNumber, genericConfig = [], statePath = 'state') {
    return (control: AbstractControl) : ValidationErrors | null => {
      // if state is empty, do not trigger the validation
      const parentValue = _.get(control.parent, 'value');
      const state = _.get(parentValue, statePath) || '';
      if (_.isEmpty(state)) {
        return null;
      }
      // get config
      const stateConfig = _.get(fieldConfig, state.toUpperCase()) || {};
      if (_.isEmpty(stateConfig)) {
        return { invalid: true };
      }
      const config = _.concat(genericConfig, stateConfig.config);
      // Validate form field using plugin
      const validationErrors = FormFieldService.validateFormField({ value: control.value }, config);
      return validationErrors;
    };
  }
}
